import React, {useEffect, useState} from "react";
import Button from "@material-ui/core/Button";
import {getSetupDoc} from "../../../../forms/tradeplans/documentation/SetupDocs";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FTFCSetup from "../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/FTFCSetup";
import {Checkbox, RadioGroup} from "@material-ui/core";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import SetupOptions from "./SetupOptions";
import CandlePatternSetup
    from "../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/CandlePatternSetup";

const setupNames = [{label: "bounce", setup: "BOUNCE"}, {label: "break", setup: "BREAK"},
    {label: "break yesterday", setup: "CANDLE_TRIGGER"},
    {label: "bounce ema", setup: "BOUNCE_EMA"},
    {label: "green takes red", setup: "BREAK_CANDLE_TYPE"}, {label: "red takes green", setup: "BREAK_CANDLE_TYPE"}];

export default function QuickSetups({top, dispatchTop, setupFields, dispatchSetUpDetails}) {
    useEffect(() => {
        if (top.setup === "none") {
            dispatchTop({setup: "AD_HOC"});
        }
    }, [top.setup]);
    let isCandlePattern = top.setup === "CANDLE_PATTERN";
    return (
        <Grid item container>
            <Grid item container xs={12}>
                <Grid item xs={3}>
                    <Button
                        size={"small"}
                        style={{
                            fontSize: 10,
                            backgroundColor: !isCandlePattern ? "blue" : "white",
                            color: !isCandlePattern ? "white" : "black",
                            height: "100%",
                            width: "100%"
                        }}
                        onClick={() => dispatchTop({setup: "AD_HOC"})}>
                        <Typography style={{fontSize: 10}}>SETUPS</Typography>
                    </Button>
                </Grid>
                <Grid item xs={4}>
                    <Button
                        size={"small"}
                        style={{
                            fontSize: 10,
                            backgroundColor: isCandlePattern ? "blue" : "white",
                            color: isCandlePattern ? "white" : "black",
                            height: "100%",
                            width: "100%"
                        }}
                        onClick={() => {
                            dispatchTop({setup: "CANDLE_PATTERN"});
                            dispatchSetUpDetails({pattern: []})
                        }}>
                        <Typography style={{fontSize: 10}}>CANDLE PATTERN</Typography>
                    </Button>
                </Grid>
            </Grid>
            {isCandlePattern ? <><CandlePatternSetup dispatchSetupDetails={dispatchSetUpDetails}
                                                     setupFields={setupFields}/></> :
                <SetupOptions dispatchSetUpDetails={dispatchSetUpDetails} setupFields={setupFields}
                              dispatchTop={dispatchTop}
                              top={top}/>
            }
        </Grid>
    )
        ;
}
